export enum EClasseBPP {
    ClasseA = 8,
    ClasseB,
    ClasseC,
    ClasseD,
}